import api from './api';

export const importesService = {
  porSiniestro: (idSiniestro) =>
    api.get(`/siniestros/${idSiniestro}/importes`),

  crear: (idSiniestro, data) =>
    api.post(`/siniestros/${idSiniestro}/importes`, data),

  actualizar: (id, data) =>
    api.put(`/importes/${id}`, data),

  eliminar: (id) =>
    api.delete(`/importes/${id}`),
};
